var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('a',{staticClass:"pro-badge",attrs:{"href":_vm.trial ? _vm.learnmore_url : _vm.plansPage,"data-testid":_vm.testid,"target":"_blank"},on:{"click":_vm.sendEvent}},[_c('span',[_vm._v("Pro")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }